/**
 * Testi italiani della Panoramica (ADR 0030 §3, tappa 6): striscia «Da fare
 * adesso», metriche, consumo per giorno con il grafico, set, attività recente e
 * siti pubblicati.
 */

/** Testi della Panoramica. */
export const overview = {
  /** Titolo. */
  title: 'Panoramica',
  /** Che cosa mostra. */
  description: 'Che cosa chiede un intervento, il consumo e lo stato dei tuoi set.',
  /** Pulsante per creare un set. */
  newSet: 'Nuovo set',

  /** Avviso di quota in cima alla pagina e nella campanella. */
  quota: {
    /** Soglia dell'80%. */
    warn80: 'Hai usato l’80% dei token del mese inclusi nel piano.',
    /** Soglia del 100%. */
    warn100: 'Hai esaurito i token del mese inclusi nel piano. I messaggi nuovi con la credenziale di institor sono bloccati.',
    /** Collegamento al consumo. */
    link: 'Vedi il consumo',
  },

  /** Striscia «Da fare adesso». */
  todo: {
    /** Titolo. */
    title: 'Da fare adesso',
    /** Conteggio delle proposte. */
    proposals: 'Proposte di task',
    /** Conteggio delle analisi. */
    analyses: 'Analisi da approvare',
    /** Conteggio dei set in errore. */
    failed: 'Set in errore',
    /** Conteggio delle credenziali mancanti. */
    credentials: 'Credenziali mancanti',
    /** Niente da fare. */
    empty: 'Niente da fare adesso.',
    /** Nome accessibile dell'elenco dei collegamenti. */
    links: 'Collegamenti a ciò che chiede un intervento',
  },

  /** Metriche. */
  metrics: {
    /** Nome accessibile della fila. */
    label: 'Metriche',
    /** Set attivi. */
    activeSets: 'Set attivi',
    /** Set attivi sul totale. */
    activeSetsValue: '{{active}} su {{total}}',
    /** Richieste in corso. */
    running: 'Richieste in corso',
    /** Richieste in coda. */
    queued_one: '{{count}} in coda',
    /** Richieste in coda. */
    queued_other: '{{count}} in coda',
    /** Token del mese. */
    tokens: 'Token del mese',
    /** Token usati sul limite. */
    tokensOfLimit: '{{used}} su {{limit}}',
    credits: 'Crediti del periodo',
    creditsPlan: '{{percent}}% del piano',
    creditsLink: 'Apri il consumo',
    /** Token usati senza limite. */
    tokensUnlimited: '{{used}}, senza limite',
    /** Costo stimato. */
    cost: 'Costo stimato {{cost}}',
    /** Minuti di voce. */
    voice: 'Minuti di voce',
    /** Minuti rimasti. */
    voiceLeft: '{{left}} rimasti',
    /** Minuti senza limite. */
    voiceUnlimited: 'Senza limite',
    /** Voce spenta sull'installazione. */
    voiceOff: 'Non attiva',
    /** Usati nel mese. */
    voiceUsed: '{{used}} usati nel mese',
  },

  /** Consumo per giorno. */
  usage: {
    /** Titolo. */
    title: 'Consumo per giorno',
    /** Sottotitolo. */
    subtitle: 'Token conteggiati dei tuoi set con la credenziale di institor, giorno per giorno (UTC).',
    /** Etichetta del periodo. */
    period: 'Periodo',
    /** Ultimi N giorni. */
    days: '{{count}} giorni',
    /** Etichetta della vista. */
    view: 'Vista',
    /** Vista grafico. */
    chart: 'Grafico',
    /** Vista tabella. */
    table: 'Tabella',
    /** Esportazione. */
    export: 'Esporta CSV',
    /** Esportazione non riuscita. */
    exportFailed: 'Esportazione non riuscita. Riprova.',
    /** Riassunto. */
    summary: 'Totale in {{days}} giorni: {{total}} token.',
    /** Giorno di picco. */
    peak: 'Picco il {{day}} con {{tokens}} token.',
    /** Costo stimato del periodo. */
    cost: 'Costo stimato: {{cost}}.',
    /** Nessun consumo. */
    empty: 'Nessun consumo nel periodo.',
    /** Nota sulla differenza con il totale del mese. */
    note: 'Conta ogni chiamata ai modelli di tutti gli agenti dei set, come i token del mese. La misura per giorno parte dal 2 novembre 2026.',
    /** Collegamento al limite. */
    limits: 'Limiti del piano',
    /** Nome accessibile del grafico. */
    chartLabel: 'Grafico del consumo per giorno. {{summary}}',
    /** Nome accessibile della legenda. */
    legend: 'Legenda',
    /** Set raggruppati. */
    others: 'Altri set',
    /** Set rimosso. */
    removedSet: 'Set rimosso',
    /** Colonna del giorno. */
    dayColumn: 'Giorno',
    /** Colonna del totale. */
    totalColumn: 'Totale',
    /** Nome accessibile della tabella. */
    tableLabel: 'Consumo per giorno e per set',
    /** Lettura non riuscita. */
    loadFailed: 'Consumo per giorno non disponibile. Riprova.',
  },

  /** Set. */
  sets: {
    /** Titolo. */
    title: 'I tuoi set',
    /** Nessun set. */
    empty: 'Nessun set di agenti.',
    /** Pulsante della riga. */
    openRelay: 'Apri l’Institore',
    /** Nome accessibile del pulsante della riga. */
    openRelayNamed: 'Apri l’Institore di {{name}}',
    /** Colonna «da fare». */
    todo: 'Da fare',
  },

  /** Attività recente. */
  activity: {
    /** Titolo. */
    title: 'Attività recente',
    /** Nessuna attività. */
    empty: 'Nessuna azione degli agenti.',
    /** Collegamento alla cronologia. */
    all: 'Apri la cronologia',
    /** Azione non riuscita. */
    failed: 'non riuscita',
    /** Lettura non riuscita. */
    loadFailed: 'Attività recente non disponibile. Riprova.',
  },

  /** Siti pubblicati. */
  sites: {
    /** Titolo. */
    title: 'Siti pubblicati',
    /** Nessun sito. */
    empty: 'Nessun sito pubblicato.',
    /** Set del sito. */
    inSet: 'Set {{name}}',
    /** Nome accessibile del collegamento. */
    openNamed: 'Apri il sito di {{name}} in una nuova scheda',
    /** Limite dei set letti. */
    partial: 'Mostra i siti dei primi {{count}} set.',
  },
};

/** Forma dei testi della Panoramica, usata per tipare le altre lingue. */
export type Overview = typeof overview;
